import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arvr-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  contents = [
    '<img src="../../../assets/AU-blr.png" alt="" style="width:160px;margin:5px;z-index:2;padding-bottom: 2%;">',
    '<img src="../../../assets/3x/AII_supportedBy.png" alt="" style="width:160px; margin:9px;z-index:2;">',
  ];

  constructor() { }

  ngOnInit(): void {
    let mbLogos = document.getElementById('mb-logos');
    let i = 0;
    mbLogos.innerHTML = this.contents[i];
    setInterval(() => {
      i += 1;
      mbLogos.innerHTML = this.contents[i % 2];
    }, 2000);
  }
}
